import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl font-semibold text-background-50 hover:text-primary-300 transition-colors cursor-pointer">
              淫乱小镇
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              在故事中，看见人性的真实。用文字探索情感的温度与深度。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-3">
              <a href="#story-categories" className="hover:text-primary-300 transition-colors">故事分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-3">
              <a href="#quick-links" className="hover:text-primary-300 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#privacy" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#terms" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  使用条款
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-3">
              <a href="#contact-info" className="hover:text-primary-300 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@hzhgjs.cn</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                <span>微信公众号：淫乱小镇</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 淫乱小镇. 保留所有权利.
          </p>
          <p className="text-xs text-background-500">
            本站内容均为原创，未经授权禁止转载
          </p>
        </div>
      </div>
    </footer>
  );
}